import Grid from "@mui/material/Grid";
import ActionCard from "components/ActionCard";

import MKBox from "components/MKBox";
import Container from "@mui/material/Container";

import databaseImage from "assets/images/admin-actions/database.jpg";
import usersImage from "assets/images/admin-actions/gebruikers.jpg";
import agentsImage from "assets/images/admin-actions/agents.jpg";
import chatbotDefaultsImage from "assets/images/admin-actions/chatbot-defaults.jpg";
import pricingImage from "assets/images/admin-actions/pricing.jpg";

function ActionsOverview() {
  const displayedCards = [
    {
      route: "/admin/chats-database",
      image: databaseImage,
      title: "Chats",
      description: "Bekijk en beheer alle chats",
    },
    {
      route: "/admin/user-database",
      image: usersImage,
      title: "Gebruikers",
      description: "Bekijk en beheer alle gebruikers",
    },
    {
      route: "/admin/agents",
      image: agentsImage,
      title: "Chatbot Logica",
      description: "Wijzig de instructies of de kennisbank van de chatbot",
    },
    {
      route: "/admin/chatbot-defaults",
      image: chatbotDefaultsImage,
      title: "Chatbot Instellingen",
      description: "De standaardberichten van de chatbot",
    },
    {
      route: "/admin/pricing",
      image: pricingImage,
      title: "Prijzen",
      description: "Alles over prijzen en abonnementen",
    },
  ];

  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container spacing={3} sx={{ mt: 3 }}>
          {displayedCards.map((card) => (
            <Grid item xs={12} md={6} lg={4} key={card.route} sx={{ mb: 3 }}>
              <MKBox sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                <ActionCard
                  route={card.route}
                  image={card.image}
                  title={card.title}
                  description={card.description}
                />
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default ActionsOverview;
